export default "__VITE_ASSET__30971676__"